import Box from '@mui/material/Box'
import type { MouseEvent } from 'react'

import { colors } from '../../KestrixDesignSystem.jsx'
import { KestrixChevronDownIcon } from '../../KestrixSvgIcons.jsx'
import KestrixV2Typography from '../../typography/KestrixTypography.tsx'

const CHEVRON_GAP_PX = 5

const triggerSx = {
  m: 0,
  p: 0,
  position: 'relative',
  border: 'none',
  background: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  gap: `${CHEVRON_GAP_PX}px`,
  color: colors.text.title,
  whiteSpace: 'nowrap',
  '&:hover, &[aria-expanded="true"]': {
    color: colors.base.KestrixPrimary,
  },
  '&:focus-visible': {
    outline: `2px solid ${colors.primary[400]}`,
    outlineOffset: 2,
    borderRadius: 1
  }
}

const chevronSx = {
  display: 'inline-flex',
  transition: 'transform 200ms ease'
}

type KestrixNavigationTriggerProps = {
  buttonId: string
  listboxId: string
  isOpen: boolean
  triggerLabel: string
  onToggle: (event: MouseEvent<HTMLButtonElement>) => void
}

export const NavigationTrigger = ({
  buttonId,
  listboxId,
  isOpen,
  triggerLabel,
  onToggle
}: KestrixNavigationTriggerProps) => (
  <Box
    id={buttonId}
    type="button"
    component="button"
    aria-haspopup="true"
    aria-expanded={isOpen}
    aria-controls={isOpen ? listboxId : undefined}
    onClick={onToggle}
    sx={triggerSx}
  >
    <KestrixV2Typography
      variant="bodyMedium"
      weight="medium"
      htmlTag="span"
    >
      {triggerLabel}
    </KestrixV2Typography>
    <Box
      aria-hidden
      component="span"
      sx={{ ...chevronSx, transform: isOpen ? 'rotate(180deg)' : 'none' }}
    >
      <KestrixChevronDownIcon size={16} color="currentColor" />
    </Box>
  </Box>
)
